// coffeelint: disable
angular.module('shared').directive('scrollableTabs', ["$timeout", function($timeout) {
  return {
    restrict: 'E',
    template: require('templates/components/shared/scrollable_tabs.html.slim'),
    transclude: true,
    link: function() {
      return $timeout(function() {
        var SETTINGS, determineOverflow, doSomething, last_known_scroll_position, pnAdvancerLeft, pnAdvancerRight, scrollableTabs, scrollableTabsContents, ticking;
        SETTINGS = {
          navBarTravelling: false,
          navBarTravelDirection: '',
          navBarTravelDistance: 150
        };
        pnAdvancerLeft = document.getElementById('pnAdvancerLeft');
        pnAdvancerRight = document.getElementById('pnAdvancerRight');
        scrollableTabs = document.getElementById('scrollableTabs');
        scrollableTabsContents = document.getElementById('scrollableTabsContents');
        doSomething = function(scroll_pos) {
          return scrollableTabs.setAttribute('data-overflowing', determineOverflow(scrollableTabsContents, scrollableTabs));
        };
        determineOverflow = function(content, container) {
          var containerMetrics, containerMetricsLeft, containerMetricsRight, contentMetrics, contentMetricsLeft, contentMetricsRight;
          containerMetrics = container.getBoundingClientRect();
          containerMetricsRight = Math.floor(containerMetrics.right);
          containerMetricsLeft = Math.floor(containerMetrics.left);
          contentMetrics = content.getBoundingClientRect();
          contentMetricsRight = Math.floor(contentMetrics.right);
          contentMetricsLeft = Math.floor(contentMetrics.left);
          if (containerMetricsLeft > contentMetricsLeft && containerMetricsRight < contentMetricsRight) {
            return 'both';
          } else if (contentMetricsLeft < containerMetricsLeft) {
            return 'left';
          } else if (contentMetricsRight > containerMetricsRight) {
            return 'right';
          } else {
            return 'none';
          }
        };
        scrollableTabs.setAttribute('data-overflowing', determineOverflow(scrollableTabsContents, scrollableTabs));
        last_known_scroll_position = 0;
        ticking = false;
        scrollableTabs.addEventListener('scroll', function() {
          last_known_scroll_position = window.scrollY;
          if (!ticking) {
            window.requestAnimationFrame(function() {
              doSomething(last_known_scroll_position);
              ticking = false;
            });
          }
          return ticking = true;
        });
        pnAdvancerLeft.addEventListener('click', function() {
          var availableScrollLeft;
          if (SETTINGS.navBarTravelling === true) {
            return;
          }
          if (determineOverflow(scrollableTabsContents, scrollableTabs) === 'left' || determineOverflow(scrollableTabsContents, scrollableTabs) === 'both') {
            availableScrollLeft = scrollableTabs.scrollLeft;
            if (availableScrollLeft < SETTINGS.navBarTravelDistance * 2) {
              scrollableTabsContents.style.transform = 'translateX(' + availableScrollLeft + 'px)';
            } else {
              scrollableTabsContents.style.transform = 'translateX(' + SETTINGS.navBarTravelDistance + 'px)';
            }
            scrollableTabsContents.classList.remove('scrollableTabs_Contents-no-transition');
            SETTINGS.navBarTravelDirection = 'left';
            SETTINGS.navBarTravelling = true;
          }
          return scrollableTabs.setAttribute('data-overflowing', determineOverflow(scrollableTabsContents, scrollableTabs));
        });
        pnAdvancerRight.addEventListener('click', function() {
          var availableScrollRight, navBarRightEdge, navBarScrollerRightEdge;
          if (SETTINGS.navBarTravelling === true) {
            return;
          }
          if (determineOverflow(scrollableTabsContents, scrollableTabs) === 'right' || determineOverflow(scrollableTabsContents, scrollableTabs) === 'both') {
            navBarRightEdge = scrollableTabsContents.getBoundingClientRect().right;
            navBarScrollerRightEdge = scrollableTabs.getBoundingClientRect().right;
            availableScrollRight = Math.floor(navBarRightEdge - navBarScrollerRightEdge);
            if (availableScrollRight < SETTINGS.navBarTravelDistance * 2) {
              scrollableTabsContents.style.transform = 'translateX(-' + availableScrollRight + 'px)';
            } else {
              scrollableTabsContents.style.transform = 'translateX(-' + SETTINGS.navBarTravelDistance + 'px)';
            }
            scrollableTabsContents.classList.remove('scrollableTabs_Contents-no-transition');
            SETTINGS.navBarTravelDirection = 'right';
            SETTINGS.navBarTravelling = true;
          }
          return scrollableTabs.setAttribute('data-overflowing', determineOverflow(scrollableTabsContents, scrollableTabs));
        });
        scrollableTabsContents.addEventListener('transitionend', (function() {
          var amount, styleOfTransform, tr;
          styleOfTransform = window.getComputedStyle(scrollableTabsContents, null);
          tr = styleOfTransform.getPropertyValue('-webkit-transform') || styleOfTransform.getPropertyValue('transform');
          amount = Math.abs(parseInt(tr.split(',')[4]) || 0);
          scrollableTabsContents.style.transform = 'none';
          scrollableTabsContents.classList.add('scrollableTabs_Contents-no-transition');
          if (SETTINGS.navBarTravelDirection === 'left') {
            scrollableTabs.scrollLeft = scrollableTabs.scrollLeft - amount;
          } else {
            scrollableTabs.scrollLeft = scrollableTabs.scrollLeft + amount;
          }
          return SETTINGS.navBarTravelling = false;
        }), false);
        return (function(root, factory) {
          return factory(root.dragscroll = {});
        })(this, function(exports) {
          var EventListener, _document, _window, addEventListener, dragged, mousedown, mousemove, mouseup, newScrollX, newScrollY, removeEventListener, reset;
          _window = window;
          _document = document;
          mousemove = 'mousemove';
          mouseup = 'mouseup';
          mousedown = 'mousedown';
          EventListener = 'EventListener';
          addEventListener = 'add' + EventListener;
          removeEventListener = 'remove' + EventListener;
          newScrollX = void 0;
          newScrollY = void 0;
          dragged = [];
          reset = function(i, el) {
            i = 0;
            while (i < dragged.length) {
              el = dragged[i++];
              el = el.container || el;
              el[removeEventListener](mousedown, el.md, 0);
              _window[removeEventListener](mouseup, el.mu, 0);
              _window[removeEventListener](mousemove, el.mm, 0);
            }
            dragged = [].slice.call(_document.getElementsByClassName('dragscroll'));
            i = 0;
            while (i < dragged.length) {
              (function(el, lastClientX, lastClientY, pushed, scroller, cont) {
                (cont = el.container || el)[addEventListener](mousedown, cont.md = function(e) {
                  if (!el.hasAttribute('nochilddrag') || _document.elementFromPoint(e.pageX, e.pageY) === cont) {
                    pushed = 1;
                    lastClientX = e.clientX;
                    lastClientY = e.clientY;
                    return e.preventDefault();
                  }
                }, 0);
                _window[addEventListener](mouseup, cont.mu = function() {
                  pushed = 0;
                }, 0);
                _window[addEventListener](mousemove, cont.mm = function(e) {
                  if (pushed) {
                    (scroller = el.scroller || el).scrollLeft -= newScrollX = -lastClientX + (lastClientX = e.clientX);
                    scroller.scrollTop -= newScrollY = -lastClientY + (lastClientY = e.clientY);
                    if (el === _document.body) {
                      (scroller = _document.documentElement).scrollLeft -= newScrollX;
                      scroller.scrollTop -= newScrollY;
                    }
                  }
                }, 0);
              })(dragged[i++]);
            }
          };
          if (_document.readyState === 'complete') {
            reset();
          } else {
            _window[addEventListener]('load', reset, 0);
          }
          return exports.reset = reset;
        });
      });
    }
  };
}]);

// coffeelint: enable
